var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxionAccelerator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 773.82 155.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#176ebf;}.cls-2{fill:#0faad6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.36,85.35V68.28H64.89L48.36,25.6,25.15,85.35H5.68L39.82,0H56.89L91,85.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.38,42.67,176.38,0h21.34l21.33,28.54L240.39,0h21.34l-32,42.67,32,42.68H240.39L219.05,56.81,197.72,85.35H176.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.29,0V85.35H381.22V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.77,85.35V0h85.35V85.35Zm68.28-17.07V17.07H534.84V68.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M688.47,85.35V0h17.07l51.21,60.54V0h17.07V85.35H756.75L705.54,26.67V85.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.19,156l1.93-7.27h7.05L25,130.51,8.3,156H0l24.33-36.38H31.6L36.38,156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.54,119.59h36.38L117,126.87H87.88L82,148.7h29.1L109.14,156H72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.3,119.59h36.38l-1.94,7.28h-29.1l-5.91,21.83h29.1L181.9,156H145.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.47,134.14h21.82l-1.93,7.28H229.53l-2,7.28h29.1L254.66,156H218.28l9.78-36.38h36.37l-1.93,7.28H233.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.42,156H291l9.77-36.38h7.28l-7.84,29.11h21.82l2.05-7.28h7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377,134.14h21.83l-1.93,7.28H375.05l-2,7.28h29.1L400.18,156H363.8l9.77-36.38H410L408,126.87h-29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.09,141.42h-7.28l-4,14.55h-7.27l9.77-36.38h36.38l-5.79,21.83H464.07L472.94,156h-9Zm-3.41-14.55-1.94,7.27h21.83l1.93-7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527.51,156l1.93-7.27h7l-2.16-18.19L517.62,156h-8.3l24.32-36.38h7.28L545.7,156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M591.85,119.59h36.38l-1.93,7.28H611.75L603.9,156h-7.27l7.84-29.1H589.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M701,119.59,691.21,156H654.83l9.78-36.38Zm-31,7.28L664,148.7h21.83l5.91-21.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.12,141.42h-7.27l-4,14.55h-7.28l9.78-36.38h36.38L768,141.42H755.11L764,156h-9Zm-3.41-14.55-1.93,7.27h21.83l1.93-7.27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxionAccelerator);
export default __webpack_public_path__ + "static/media/AxionAccelerator.d9c7b84ff2f4119c7d937e7fd45de2f7.svg";
export { ForwardRef as ReactComponent };